import axios from '../../v2/app/services/axiosService';
import {orderBy} from 'lodash';

export default {
  async getCountries() {
    const response = await axios.get(`/api/countries`);
    
    // First sort all countries alphabetically
    const sortedCountries = orderBy(response.data, ['name'], ['asc']);

    // Find and remove US and Canada from the sorted array
    const us = sortedCountries.find(country => country.id === 'US');
    const canada = sortedCountries.find(country => country.id === 'CA');

    // Filter out US and Canada from the main array
    const otherCountries = sortedCountries.filter(
      country => country.id !== 'US' && country.id !== 'CA'
    );

    // Create the final array with US and Canada at the top
    const result = [];
    if (us) result.push(us);
    if (canada) result.push(canada);

    // Concatenate with the rest of the countries
    return [...result, ...otherCountries];
  },
  async getCountry(countryCode) {
    const response = await axios.get(`/api/countries/${countryCode}`);
    return response.data;
  }
}
